var render, staticRenderFns
import script from "./ICieBooking.vue?vue&type=script&lang=js&"
export * from "./ICieBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b16c41f')) {
      api.createRecord('5b16c41f', component.options)
    } else {
      api.reload('5b16c41f', component.options)
    }
    
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/ICieBooking.vue"
export default component.exports